module.exports = __webpack_public_path__ + "assets/img/page1-design-side-nav-expanded-1-df6768c5.png";